export default __webpack_public_path__ + "d165aa26ae26e711be39e76604a5562b.svg";